export const LOWER_SCROLL_THRESHOLD_SELECTOR = '#gc-footer, footer';
